<template>
    <b-card
        no-body
        border-variant="light"
    >
        <div class="card-header">
            <div class="col-md-6 pl-0">
                <b-card-title>
                    {{ $t('Page(ProductCard):Component(Text):compliance-overview') }}
                </b-card-title>
            </div>
        </div>
        <b-table
            :fields="fields"
            :items="items"
            responsive="sm"
        >
            <template #cell(legislation)="data">
                <div :title="$t('Component(ComplianceOverview):hover-legislation')">
                    {{ data.item.legislation.title }}
                </div>
            </template>
            <template #cell(legalRole)="data">
                <div
                    :title="$t('Component(ComplianceOverview):hover-legalRole')"
                    class="demo-inline-spacing"
                >
                    <b-badge
                        v-for="role in data.item.legalRoles"
                        :key="role.id || role.title"
                    >
                        {{ role.title }}
                    </b-badge>
                </div>
            </template>
            <template #cell(event)="data">
                <div :title="$t('Component(ComplianceOverview):hover-event')">
                    {{ data.value.title }}
                </div>
            </template>
            <template #cell(status)="data">
                <ComplianceStatusExplanation
                    v-if="data.value"
                    :product-id="productId"
                    :legislation-id="data.item.legislation.id"
                    :revision="statusExplanationRevision"
                    show-description
                >
                    <template #default="{ state, toggle }">
                        <span
                            :title="$t('Component(ComplianceOverview):hover-status')"
                            class="compliance-status"
                            :class="'compliance-status-' + state"
                            @click.stop="toggle"
                        >
                            <ShimmerText :active="state === 'loading'">
                                {{ data.value.title }}
                            </ShimmerText>
                        </span>
                    </template>
                </ComplianceStatusExplanation>
            </template>
        </b-table>
    </b-card>
</template>

<script>
import {
    BBadge, BCard, BCardTitle, BTable,
} from 'bootstrap-vue'
// eslint-disable-next-line import/no-cycle
import LegislationApi from '@core/api/request/legislation'
import ShimmerText from '@core/components/common/ShimmerText.vue'
import ComplianceStatusExplanation from './ComplianceStatusExplanation.vue'

export default {
    components: {
        BCard,
        BCardTitle,
        BTable,
        BBadge,
        ShimmerText,
        ComplianceStatusExplanation,
    },
    props: {
        productId: {
            type: [Number, String],
            required: true,
        },
        statusExplanationRevision: {
            type: Number,
            default: 1,
        },
        eventStatuses: {
            type: Object,
            default() {
                return {}
            },
        },
        legalRoles: {
            type: Array,
            default() {
                return []
            },
        },
    },
    data() {
        return {
            fields: [
                // A column that needs custom formatting
                {
                    key: 'legislation',
                    label: this.$t('Component(ComplianceOverview):column-legislation'),
                    headerTitle: this.$t('Component(ComplianceOverview):hover-legislation'),
                },
                {
                    key: 'legalRole',
                    label: this.$t('Component(ComplianceOverview):column-legalRole'),
                    headerTitle: this.$t('Component(ComplianceOverview):hover-legalRole'),
                },
                {
                    key: 'event',
                    label: this.$t('Component(ComplianceOverview):column-event'),
                    headerTitle: this.$t('Component(ComplianceOverview):hover-event'),
                },
                {
                    key: 'status',
                    label: this.$t('Component(ComplianceOverview):column-status'),
                    headerTitle: this.$t('Component(ComplianceOverview):hover-status'),
                },
            ],
            legislations: [],
        }
    },
    computed: {
        items() {
            return this.legislations.map(legislation => {
                const legalRoleObject = this.legalRoles.find(r => r.legislationId === legislation.id)
                const eventStatus = this.eventStatuses[legislation.id]
                let legalRoles = []

                if (legalRoleObject) {
                    legalRoles = legalRoleObject.legalRoles
                }

                return {
                    legislation,
                    legalRoles,
                    event: eventStatus ? eventStatus.event : '',
                    status: eventStatus ? eventStatus.status : '',
                }
            })
        },
    },
    created() {
        LegislationApi.all().then(r => {
            this.legislations = r.data
        })
    },
}
</script>

<style scoped lang="scss">
.compliance-status {
    border-bottom: 1px dotted currentColor;
    cursor: pointer;
    display: inline-block;
    margin: -0.125rem -0.375rem;
    outline: none;
    padding: 0.125rem 0.375rem;
}

.compliance-status-loading {
    cursor: wait;
}

.compliance-status-error {
    color: #ea5455;
}
</style>
